var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0832 12.9375C12.3513 12.9375 13.3719 11.925 13.3719 10.6875V5.4375C13.3719 4.2 12.3513 3.1875 11.0832 3.1875C9.81503 3.1875 8.79443 4.2 8.79443 5.4375V10.6875C8.79443 11.925 9.81503 12.9375 11.0832 12.9375Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7902 10.6406C18.7902 10.5375 18.7061 10.4531 18.6034 10.4531H17.2021C17.0993 10.4531 17.0153 10.5375 17.0153 10.6406C17.0153 13.9289 14.3599 16.5938 11.0832 16.5938C7.80658 16.5938 5.15117 13.9289 5.15117 10.6406C5.15117 10.5375 5.06709 10.4531 4.96433 10.4531H3.56306C3.4603 10.4531 3.37622 10.5375 3.37622 10.6406C3.37622 14.5945 6.3329 17.857 10.149 18.3187V20.7188H6.75562C6.43566 20.7188 6.17876 21.0539 6.17876 21.4688V22.3125C6.17876 22.4156 6.24416 22.5 6.32356 22.5H15.8429C15.9223 22.5 15.9877 22.4156 15.9877 22.3125V21.4688C15.9877 21.0539 15.7308 20.7188 15.4108 20.7188H11.924V18.3305C15.7845 17.9086 18.7902 14.6273 18.7902 10.6406Z",
    fill: "#828292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0831 14.625C13.2761 14.625 15.0533 12.8625 15.0533 10.6875V5.4375C15.0533 3.2625 13.2761 1.5 11.0831 1.5C8.89007 1.5 7.11279 3.2625 7.11279 5.4375V10.6875C7.11279 12.8625 8.89007 14.625 11.0831 14.625ZM8.79432 5.4375C8.79432 4.2 9.81491 3.1875 11.0831 3.1875C12.3512 3.1875 13.3718 4.2 13.3718 5.4375V10.6875C13.3718 11.925 12.3512 12.9375 11.0831 12.9375C9.81491 12.9375 8.79432 11.925 8.79432 10.6875V5.4375Z",
    fill: "#828292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/Mic.d033d307.svg";
export { ForwardRef as ReactComponent };